import React from 'react'
import NgrxDate from '../util/NgrxDateHelper'
import { localize, getFullLocale } from '../util/Localizer'
import Config from '../Config'

const TitledLabel = (props) => {
  // format the data if required
  let { value, rawTitle, tooltip, className, preTranslatedTitle } = props
  let title = rawTitle ? props.title : localize(props.title)
  if (!props.showRaw) {
    switch (props.format) {
      case 'date':
        if (value !== 'N/A') {
          value = NgrxDate.SetDate(value)
        }
        break
      case 'dateRange':
        value = [NgrxDate.SetDate(value[0]), NgrxDate.SetDate(value[1])]
        if (value.indexOf(Config.defaultDateValue) >= 0) {
          value = Config.defaultDateRange
        }
        break
      case 'currency':
        // Fix to support safari 9.1 which doesn't support intl and the polyfill isn't complete
        let curr = Intl.NumberFormat(getFullLocale(), { style: 'currency', currency: 'CAD' }).format(value || 0).replace('CA', '')
        value = (<span>{ curr }</span>)
        break
      default:
        break
    }
  }

  // if it's empty set a default value
  if (value === null || value === undefined || value.length === 0) {
    value = localize('titledLabelNotAvailable')
  }

  // Here we are checking for divs so that we don't put them into a p tag :)
  if (typeof (value) === 'string') {
    value = (<p className={'titledLabelLabel'}>{value}</p>)
  } else if (typeof (value) === 'object' && props.format === 'dateRange') {
    value = (<p className='titledLabelLabel'><span>{value[0]}</span> {localize('common.preposition.to')} <span>{value[1]}</span></p>)
  } else {
    value = (<div className={'titledLabelLabel'}>{value}</div>)
  }

  // return the component
  return (
    <div className='titledLabel'>
      {preTranslatedTitle ? <p className='titledLabelTitle'>{preTranslatedTitle}</p> : <p className='titledLabelTitle'>{title}{tooltip || ''}</p>}
      <span className={`${(className || '').toLowerCase()}`}>{value}</span>
    </div>
  )
}

export default TitledLabel



// WEBPACK FOOTER //
// ./src/controls/TitledLabel.js